if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || sensibo.money_with_currency_format);
    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}


class DynamicVideo extends HTMLElement { 
  constructor() {
    super();
    this.togglePlay = this.togglePlay.bind(this);
    this.toggleMute = this.toggleMute.bind(this);
    this.updateState = this.updateState.bind(this);
    this.updateMuteState = this.updateMuteState.bind(this);
  }

  connectedCallback() {
    this.video = this.querySelector('video');
    this.playButton = this.querySelector('.videos-slider__action-button');
    this.muteButton = this.querySelector('.videos-slider__mute-button');

    if (!this.video || !this.playButton || !this.muteButton) return;

    // Play / Pause
    this.playButton.addEventListener('click', this.togglePlay);
    this.video.addEventListener('play', this.updateState);
    this.video.addEventListener('pause', this.updateState);
    this.video.addEventListener('ended', this.updateState);

    // Mute / Unmute
    this.muteButton.addEventListener('click', this.toggleMute);
    this.video.addEventListener('volumechange', this.updateMuteState);

    this.updateState();
    this.updateMuteState();
  }

  disconnectedCallback() {
    // Play / Pause
    this.playButton.removeEventListener('click', this.togglePlay);
    this.video.removeEventListener('play', this.updateState);
    this.video.removeEventListener('pause', this.updateState);
    this.video.removeEventListener('ended', this.updateState);

    // Mute / Unmute
    this.muteButton.removeEventListener('click', this.toggleMute);
    this.video.removeEventListener('volumechange', this.updateMuteState);
  }

  togglePlay() {
    if (this.video.paused) {
      this.video.play();
    } else {
      this.video.pause();
    }
  }

  toggleMute() {
    this.video.muted = !this.video.muted;
  }

  updateState() {
    this.classList.toggle('paused', this.video.paused);
    this.classList.toggle('playing', !this.video.paused);
  }

  updateMuteState() {
    this.classList.toggle('muted', this.video.muted);
    this.classList.toggle('unmuted', !this.video.muted);
  }
}

customElements.define('dynamic-video', DynamicVideo);


document.addEventListener('DOMContentLoaded', function() {
  function adjustSuggestionsMargin() {
    const cartRows = document.querySelectorAll('.shopping-cart__row');
    const productSuggestions = document.querySelector('.products-suggestions-new');
    const shoppingCartTable = document.querySelector('.shopping-cart__table');
    const cartFooter = document.querySelector('.cart__footer');
    const shieldSuggestions = document.querySelector('.sheild-suggestions');


    if (window.innerWidth <= 749 && productSuggestions && cartRows.length > 0) {
      let baseMargin = 250;

      const additionalMargin = cartRows.length * 50;

      shoppingCartTable.style.marginBottom = '0px';
      cartFooter.style.marginBottom = '0px';

      const totalMargin = baseMargin + additionalMargin;

      if (shieldSuggestions) {
        productSuggestions.style.marginBottom = '0px';
      } else {
        productSuggestions.style.marginBottom = `${totalMargin}px`;
      }
    }
  }

  adjustSuggestionsMargin();

  document.addEventListener('cart:updated', adjustSuggestionsMargin);

  const cartContainer = document.querySelector('.cart__items');
  if (cartContainer) {
    const observer = new MutationObserver(adjustSuggestionsMargin);
    observer.observe(cartContainer, { childList: true, subtree: true });
  }
});
